module.exports = __webpack_public_path__ + "img/social_1.90a80949.svg";